// Components
import ServicesList from "../components/services/ServicesList";
import Hero from "../components/layout/Hero";

// Assets
import "../assets/styles/services.css";
import heroImg from "../assets/images/services/hero.jpg";

// Hooks
import { useTranslation } from "../hooks/useTranslation";

export default function Services() {
  const t = useTranslation();

  return (
    <section id="servicesSection">
      <Hero
        bgImage={heroImg}
        title={t("services.title")}
      />

      <ServicesList className="serviceList" />
    </section>
  );
}
